
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from "vuex-class";

import ExpandIcon from "@/components/utils/ExpandIcon.vue";

import "@/store/modules/forms/form2";
const form2State = namespace("Form2");

@Component({
    components:{
        ExpandIcon
    }
})
export default class NoticeOfAppearanceRspToLeavePg extends Vue {
    
    @form2State.Action
    public UpdateCurrentCaseId!: (newCurrentCaseId: string) => void     
    
    showNoaServedInfo = true;
    showServeNoaInfo = false;
    showNotFileNoaInfo = false;
        
    public startNewDocument(){
        this.UpdateCurrentCaseId(null);
        this.$router.push({name: "start-form2" })
    }

    public showNoaServed(show: boolean){
        if (show) {
            this.showNoaServedInfo = true;
            this.$emit('adjustHeights', 0, "14rem");
        } else {
            this.showNoaServedInfo = false;
            this.$emit('adjustHeights', 0, "0");
        }        
    }

    public showServeNoa(show: boolean){
        if (show) {
            this.showServeNoaInfo = true;
            this.$emit('adjustHeights', 1, "28.5rem")
        } else {
            this.showServeNoaInfo = false;
            this.$emit('adjustHeights', 1, "0");
        }
    }

    public showNotFileNoa(show: boolean){
        if (show) {
            this.showNotFileNoaInfo = true;
            this.$emit('adjustHeights', 2, "5rem")
        } else {
            this.showNotFileNoaInfo = false;
            this.$emit('adjustHeights', 2, "0");
        }
    }

}
